function HalfTriangle(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M480 480H0V0l480 480z"></path></svg>
    )
}

export default HalfTriangle